/**
 *  Keeps the text under a promotion the same height as a product card's info area,
 *  so the promotion image lines up with the product images beside it.
 */
(function () {
  var OFFSET = -1;

  var sync = function () {
    document.querySelectorAll('.gallery__item--text-below').forEach(function (item) {
      var column = item.closest('.promotion-column'),
        grid = column ? column.parentElement : null;

      if (!grid) {
        return;
      }

      // Measure the nearest product card after the promotion, else the first one in the grid
      var card = null,
        sibling = column.nextElementSibling;

      while (sibling && !card) {
        card = sibling.querySelector('.product-card');
        sibling = sibling.nextElementSibling;
      }
      if (!card) {
        card = grid.querySelector('.product-card');
      }
      if (!card) {
        return;
      }

      var image = card.querySelector('.product-card--featured-image'),
        info = card.querySelector('.product-card-info');

      if (!image || !info) {
        return;
      }

      // Gap below the image plus the info area, which is what sits under a product image
      var height = info.getBoundingClientRect().bottom - image.getBoundingClientRect().bottom;

      // Rounding the measurement up overshoots by a pixel, so OFFSET trims it back down.
      if (height > 0) {
        item.style.setProperty('--promo-below-height', Math.ceil(height) + OFFSET + 'px');
      }
    });
  };

  var frame,
    schedule = function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    };

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('pagination:page-changed', schedule);

  // Filtering and sorting replace the grid markup
  var container = document.getElementById('ProductGridContainer');
  if (container && window.MutationObserver) {
    new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
  }

  // Product images are lazy-loaded, so heights settle after they arrive
  if (window.ResizeObserver) {
    var observer = new ResizeObserver(schedule);
    document.querySelectorAll('.products').forEach(function (grid) {
      observer.observe(grid);
    });
  }
})();
